import { SET_USER, SET_LOADING, SET_NEW_USER } from '../actions/auth';

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  user: {},
  organization: {},
};

const state = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: action.loading,
        user: {},
      };
    case SET_USER:
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
        isLoading: false,
        user: action.user,
        organization: action.org,
      };
    case SET_NEW_USER:
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
        isLoading: false,
        user: action.user,
        organization: action.org,
        newUser: true,
      };
    default:
      return state;
  }
};

export default state;
